import { format, parseISO } from "date-fns"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function UpdateBrandingImage(implementationID: number, implementationImageID: number, activeDate?: string, inactiveDate?: string) {
  const requestBody: string = JSON.stringify({
    ImplementationID: implementationID,
    ImplementationImageID: implementationImageID,
    ActiveDate: format(parseISO(activeDate || ""), "MM/dd/yyyy"),
    InActiveDate: format(parseISO(inactiveDate || ""), "MM/dd/yyyy")
  })

  return ObservableFromFetch<string>("FFOrderClientFileMaintenance/UpdateImplementationImage", requestBody)
}
